function MobileMenu($) {
    return {
        menuConfig: {
            mobileMenuBtn: '#mobile-menu-btn',
            menuID: '#main-navigation',
            subMenuClass: '.menu-item-has-children'
        },
        init: function () {
            let self = this;

            $(window).resize(function() {
                if ($(window).width() > 1184) {
                    $(self.menuConfig.menuID).css('display','');
                    $(self.menuConfig.mobileMenuBtn).removeClass('open');
                }
            });

            self.toggleMenu(self.menuConfig.mobileMenuBtn);

            $(self.menuConfig.subMenuClass).not('.menu-item-has-children .menu-item-has-children').find('>a').on('click', function (e) {
                if ($(window).width() < 1184) {
					if ( ! $(this).hasClass( 'expanded' ) ) {
						e.preventDefault();
						self.toggleSubMenu(this);
					}
                }
            });
        },
        toggleMenu: function (btnID) {
            let self = this;

            $(btnID).on('click', function () {
                $(this).toggleClass('open');
                $(self.menuConfig.menuID).slideToggle('fast');
            });

        },
        toggleSubMenu: function (btn) {
            let self = this;

            $(btn).toggleClass('expanded').next('ul').slideToggle();

        }
    }
}


jQuery(function ($) {
    let mobileMenu = new MobileMenu($);
    mobileMenu.init();
});
